export const CampoColaborador = Object.freeze({
    PERFIL: "PERFIL",
    SEDE: "SEDE",
    SUBSEDE: "SUBSEDE",
    SECCION:"SECCION",
    CARGO:"CARGO",
    PLANILLA:"PLANILLA",
    SINCAMPO:"SINCAMPO"
});